var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w8q4ij76ca",
    d: "M21.998 17C22.55 17 23 16.556 23 16c0-.552-.44-1-1.002-1H2.002C1.45 15 1 15.444 1 16c0 .552.44 1 1.002 1h19.996zm0-4C22.55 13 23 12.556 23 12c0-.552-.44-1-1.002-1H2.002C1.45 11 1 11.444 1 12c0 .552.44 1 1.002 1h19.996zM1 8c0 .552.44 1 1.002 1h19.996C22.55 9 23 8.556 23 8c0-.552-.44-1-1.002-1H2.002C1.45 7 1 7.444 1 8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-320 -220) translate(320 220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uz0mi9q55b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w8q4ij76ca"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D0D3D9",
    mask: "url(#uz0mi9q55b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.1eae9d9209eb7c93c6b6732bc34dc52a.svg";
export { ForwardRef as ReactComponent };